var _path, _path2, _path3, _path4, _g, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoneMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 42,
    viewBox: "0 0 38 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9261 1.77952L3.96201 8.80439C2.12704 9.88181 1 11.8505 1 13.9784V28.0216C1 30.1495 2.12704 32.1182 3.96201 33.1956L15.9261 40.2205C17.7979 41.3195 20.1172 41.3219 21.9913 40.2268L34.0272 33.1936C35.8682 32.1178 37 30.1456 37 28.0132V13.9868C37 11.8544 35.8682 9.88223 34.0272 8.80638L21.9913 1.77318C20.1172 0.67808 17.7979 0.680505 15.9261 1.77952Z",
    fill: "white",
    stroke: "#ECE9F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2146 4.21345L6.34538 10.0508C4.51976 11.1306 3.3999 13.094 3.3999 15.2151V26.9794C3.3999 29.1004 4.51976 31.0639 6.34538 32.1437L16.2146 37.981C18.0946 39.093 20.4304 39.0954 22.3128 37.9874L32.2436 32.1417C34.0753 31.0635 35.1999 29.0966 35.1999 26.971V15.2234C35.1999 13.0979 34.0753 11.131 32.2436 10.0527L22.3128 4.20705C20.4304 3.09902 18.0946 3.10147 16.2146 4.21345Z",
    fill: "#1CA388"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3143 6.75556L8.83929 11.2069C7.02237 12.2889 5.90918 14.2474 5.90918 16.3621V25.4488C5.90918 27.5635 7.02237 29.522 8.83929 30.604L16.3143 35.0553C18.202 36.1794 20.5531 36.1819 22.4432 35.0618L29.9682 30.6021C31.7913 29.5216 32.9092 27.5596 32.9092 25.4404V16.3704C32.9092 14.2512 31.7913 12.2892 29.9682 11.2088L22.4432 6.74911C20.5531 5.62896 18.202 5.63144 16.3143 6.75556Z",
    fill: "#6FCF97"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_401_140",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 28,
    height: 31
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3143 6.75556L8.83929 11.2069C7.02237 12.2889 5.90918 14.2474 5.90918 16.3621V25.4488C5.90918 27.5635 7.02237 29.522 8.83929 30.604L16.3143 35.0553C18.202 36.1794 20.5531 36.1819 22.4432 35.0618L29.9682 30.6021C31.7913 29.5216 32.9092 27.5596 32.9092 25.4404V16.3704C32.9092 14.2512 31.7913 12.2892 29.9682 11.2088L22.4432 6.74911C20.5531 5.62896 18.202 5.63144 16.3143 6.75556Z",
    fill: "#FFC100"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_401_140)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.90918,
    y: 5.7538,
    width: 13.0909,
    height: 30.4129,
    fill: "#6FCF97"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15.5404L16.75 23.3105L13 19.7786",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneMedal);
export default __webpack_public_path__ + "static/media/doneMedal.0045b3682b0c73125077b98b4bd52622.svg";
export { ForwardRef as ReactComponent };